import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Urls } from 'src/app/Helpers/Urls';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  url = new Urls();
  apiUrl: string;
  orgId: number;

  constructor(
    private http: HttpClient
  ) {
      this.apiUrl = this.url.apiUrl;
  }

  async login(userName: string, passWord: string) {
    return this.authenticate(
      userName,
      passWord
    ).toPromise();
  }

  authenticate(email: string, passWord: string) {
    return this.http.get<any>(
      this.apiUrl +
        '/api/validateuser/0/0/' +
        email +
        '/ /' +
        passWord +
        '/ /1'
    );
  }
}
